import { Component, OnInit } from "@angular/core";
import { ContractService } from "app/auth/service/contract.service";
import { locale as italian } from "../../../../i18n/it";
import moment from "moment";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-contract-list",
  templateUrl: "./contract-list.component.html",
  styleUrls: ["./contract-list.component.scss"],
})
export class ContractListComponent implements OnInit {
  public contentHeader: IContentHeader;
  public user_type_name: string = italian.data.MENU.CONTRACT_LIST;
  public filter_string: string = "";
  public type_contract_list: any = [];
  public filtered_contract_list: any = [];
  public contract_list: any;
  public tableLimit: number = 10;
  public filter_type: number = -1;
  public currentDate: any = moment().format("YYYY-MM-DD");
  public lastMonth: any = moment().subtract(30, "days").format("YYYY-MM-DD");
  public nextMonth: any = moment().add(30, "days").format("YYYY-MM-DD");
  public day_start: any;
  public day_end: any;

  constructor(
    private _contractService: ContractService,
    public _utilsService: UtilsService,
    public _authenticationService: AuthenticationService,
  ) {
    this.contentHeader = {
      headerTitle: this.user_type_name,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.USERS,
            isLink: false,
          },
          {
            name: italian.data.MENU.CONTRACT_LIST,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    this.contract_list = await this._contractService.getAllContractUsers().then((items: any) => {
      return items.map((item: any) => {
        item.class_name = "";
        // Inserito negli ultimi 30 giorni
        if (moment(item.start_date).format("YYYY-MM-DD") > this.lastMonth && moment(item.start_date).format("YYYY-MM-DD") <= this.currentDate) {
          item.class_name = "last";
          item.tooltip = "IS_LAST";
        } else if (moment(item.start_date).format("YYYY-MM-DD") > this.currentDate) {
          // Deve iniziare
          item.class_name = "start";
          item.tooltip = "IS_START";
        } else if (item.end_date) {
          // Contratto in scadenza
          if (moment(item.end_date).format("YYYY-MM-DD") > this.lastMonth && moment(item.end_date).format("YYYY-MM-DD") < this.nextMonth) {
            item.class_name = "ending";
            item.tooltip = "IS_ENDING";
          }
        }
        // Ha presentato le dimissioni
        if (item.closed_at) {
          item.class_name = "fired";
          item.tooltip = "IS_FIRED";
        }
        return item;
      });
    });
    await this.search();
    this.type_contract_list = await this._contractService.getList();
  }

  async search() {
    const keyword: string = this.filter_string.toLowerCase().trim();
    let filteredList: any = this.contract_list;
    if (keyword.length > 0) {
      filteredList = filteredList.filter((item: any) => {
        return (
          item.complete_name.toLowerCase().includes(keyword) || item.contract_name.toLowerCase().includes(keyword) || item?.level?.toLowerCase().includes(keyword) || item.salary_yearly_gross.toString().includes(keyword)
        );
      });
    }
    if (this.filter_type > -1) {
      filteredList = filteredList.filter((item: any) => Number(item.contract) === Number(this.filter_type));
    }

    if (this.day_start) {
      const dayStart = moment(this.day_start);
      filteredList = filteredList.filter((item: any) => moment(item.start_date) >= dayStart);
    }

    if (this.day_end) {
      const dayEnd = moment(this.day_end);
      filteredList = filteredList.filter((item: any) => moment(item.end_date) <= dayEnd);
    }

    filteredList = filteredList.map((item: any) => ({ ...item, ticket: item.ticket ? Number(item.ticket) : 0, ticket_value: item.ticket_value ? Number(item.ticket_value) : 0 }));

    this.filtered_contract_list = filteredList;
  }

  async exportContracts() {
    if (!this._authenticationService.hasCapability("export_employees_contracts_list")) {
      return false;
    }
    let fullData: any = this.filtered_contract_list;
    if (!!fullData && fullData.length > 0) {
      return this._utilsService.exportAsExcelFile(
        fullData.map((contract: any) => {
          return {
            "Nome e Cognome": contract.complete_name ? contract.complete_name : "-",
            Nome: contract.firstname ? contract.firstname : "-",
            Cognome: contract.lastname ? contract.lastname : "-",
            Contratto: contract.contract_name ? contract.contract_name : "-",
            Livello: contract.level ? contract.level : "-",
            "Data inizio": contract.start_date ? this._utilsService.formatDate(contract.start_date) : "-",
            "Data fine": contract.end_date ? this._utilsService.formatDate(contract.end_date) : "-",
            RAL: contract.salary_yearly_gross ? this._utilsService.addDotsToNumber(contract.salary_yearly_gross) : "0,00",
            Ticket: contract.ticket_value ? this._utilsService.addDotsToNumber(contract.ticket_value) : "0,00",
            Bonus: contract.bonus ? this._utilsService.addDotsToNumber(contract.bonus) : "0,00",
            "Costo giornaliero": contract.total_daily ? this._utilsService.addDotsToNumber(contract.total_daily) : "0,00",
            "Importo TFR": contract.tfr_amount ? this._utilsService.addDotsToNumber(contract.tfr_amount) : "0,00",
          };
        }),
        "export-users-contracts",
      );
    }
  }
}
